import React from 'react';
import { Box } from '@mui/material';
import TopUtilityBar from '@/components/sections/TopUtilityBar';
import HeaderNav from '@/components/sections/HeaderNav';
import CapabilitiesSection from '@/components/sections/CapabilitiesSection';
import FooterSection from '@/components/sections/FooterSection';

export const CapabilitiesPage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#0b0f19' }}>
      <TopUtilityBar />
      <HeaderNav />
      <CapabilitiesSection />
      <FooterSection />
    </Box>
  );
};

export default CapabilitiesPage;
